import { NodeModel } from "../_model/NodeModel";
import { DecorationDryer } from "./decorationDryer";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Dryer extends NodeModel {
  constructor() {
    super("Dryer");

    this.type = new Types().Dryer;

    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 130;
    this.width = 180;
    this.operationSelected = "";
    this.srcImg = require("@/assets/Fluxogramas/secador.png");
    this.data = [new Properties({ ...this })];
    this.CurrentOcupacaoCalc = null;
    this.CurrentCapaProd = null;
    this.dryers = [];

    this.decorate = async function(callback) {
      this.decorator = new DecorationDryer();
      await this.decorator.init(this, callback);
    };

    this.clone = () => {
      let cloned = new Dryer();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.decorator = null;
      cloned.readOnly = this.readOnly
			cloned.expressionVisible = this.expressionVisible
      cloned.data = this.data.map(d => d.clone());
      cloned.CurrentOcupacaoCalc = this.CurrentOcupacaoCalc;
      cloned.CurrentCapaProd = this.CurrentCapaProd;
      cloned.dryers = this.dryers;

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.data = node.data.map((d) => new Properties({ ...d }));
      this.CurrentOcupacaoCalc = node.CurrentOcupacaoCalc;
      this.CurrentCapaProd = node.CurrentCapaProd;
      this.dryers = node.dryers;
    };

    this.update = (node) => {
      console.log('node :>> ', node);
      if (node.attrs) {
        this.data = node.attrs;
      }
      if (node.CurrentOcupacaoCalc)
        this.CurrentOcupacaoCalc = node.CurrentOcupacaoCalc;

      if (node.CurrentCapaProd)
        this.CurrentCapaProd = node.CurrentCapaProd;

      if (node.dryers)
        this.dryers = node.dryers;
    };
  }
}

export { Dryer };
